import { attr } from "@microsoft/fast-element";
import { accordionAnchorTemplate } from "./accordion-anchor.template";
import { accordionAnchorStyles } from "./accordion-anchor.styles";
import { NatGenAccordionItem } from "../accordion-item/accordion-item";
import { NatGenDesignSystem } from "../../natgen-design-system";

/**
 * @element natgen-accordion-anchor
 */
export class NatGenAccordionAnchor extends NatGenAccordionItem {
    @attr
    href: string;

    @attr
    target: string;
}

export const natGenAccordionAnchorDefinition = NatGenAccordionAnchor.compose({
    name: `${NatGenDesignSystem.prefix}-accordion-anchor`,
    template: accordionAnchorTemplate(),
    styles: accordionAnchorStyles
});
